import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import type { Id } from '@/types/api';

export interface MarkNotificationAsReadResponse {
  message: string;
}

export const markNotificationAsRead = async (notificationId: Id): Promise<MarkNotificationAsReadResponse> => {
  const response = await apiClient.patch<MarkNotificationAsReadResponse>(`/v1/notifications/${notificationId}/mark-as-read`);
  return response.data;
};

interface UseMarkNotificationAsReadOptions {
  id: Id;
  options?: MutationOptions<MarkNotificationAsReadResponse>;
}

export const useMarkNotificationAsRead = ({ options, id }: UseMarkNotificationAsReadOptions) => {
  return useMutation({
    mutationKey: ['markNotificationAsRead', id],
    mutationFn: () => markNotificationAsRead(id),
    ...options,
  });
};
